<template>
	<div class="board">
		<img class="board-img zoom" src="../assets/ttop.png"
				 data-magnify-src="/static/ttop.png"
				 :class="{ show:isShow(2) }"
				 alt="ttop"
		>
		<img class="board-img _bottom"
				 src="../assets/tbase.png"
				 :class="{ show:isShow(2) }"
				 alt="tbase"
		>
		<img class="board-img zoom" src="../assets/ftop.png"
				 data-magnify-src="/static/ftop.png"
				 :class="{ show:isShow(3) }"
				 alt="ftop"
		>
		<img class="board-img _bottom"
				 :src="fSrc"
				 :class="{ show:isShow(3) }"
				 alt="fbase"
		>
		<div class="toggle __f" :class="{ show:isShow(3),  fSec:changeColor(3) }" v-on:click="toggle(3)">
		</div>
		<img class="board-img zoom" src="../assets/utop.png"
				 data-magnify-src="/static/utop.png"
				 :class="{ show:isShow(4) }"
				 alt="utop"
		>
		<img class="board-img _bottom"
				 :src="uSrc"
				 :class="{ show:isShow(4) }"
				 alt="ubase"
		>
		<div class="toggle __u" :class="{ show:isShow(4),  uSec:changeColor(4) }" v-on:click="toggle(4)">
		</div>
	</div>
</template>

<script>
  import 'magnify';

  export default {
    name: 'board',
    props: ['active'],
    data () {
      return {
        fCount: 0,
        fSrc: require('../assets/fbase.png'),
        fImg: require('../assets/fbase.png'),
        fImg2: require('../assets/fbase2.png'),
        uCount: 0,
        uSrc: require('../assets/ubase.png'),
        uImg: require('../assets/ubase.png'),
        uImg2: require('../assets/ubase2.png')
			}
    },
    methods: {
      isShow: function (index) {
        return this.active === index
      },
			toggle: function (i) {
				if (i === 3) {
				  if (this.fCount === 0) {
            this.fSrc = this.fImg2
						this.fCount++
          } else {
            this.fSrc = this.fImg
            this.fCount--
					}
				} else if ( i === 4 ) {
          if (this.uCount === 0) {
            this.uSrc = this.uImg2
            this.uCount++
          } else {
            this.uSrc = this.uImg
            this.uCount--
          }
				}
      },
			changeColor: function (i) {
				if (i === 3) {
          return this.fCount === 1
				} else {
				  return this.uCount === 1
				}
      }
    },
    components: {
      $
    },
    mounted () {
      var width = $(window).width();
      if (width >= 1250) {
        $(document).ready(function () {
          $('.zoom').magnify({
            speed: 100
          });
        });
      }
    },
    watch: {}
  }
</script>

<style scoped>
	@import url(../assets/plugin/css/magnify.css);

	.board {
		position: relative;
		height: 500px;
		width: 12vw;
		margin: 0 auto;
	}

	.board-img {
		left: -1200px;
		position: absolute;
		z-index: 101;
		height: 937px;
		top: -441px;
		opacity: 0;
		transition: all ease-out .6s, opacity ease-out .3s;
	}

	._bottom {
		top: -369px;
		height: 782px;
		left: -1200px;
		z-index: 100;
	}

	.show {
		opacity: 1;
		left: 25px;
		transform: translateX(0);
		transition: all ease-out .6s, opacity ease-out .3s;
	}

	._bottom.show {
		left: -67px;
		transition: all ease-out .7s;
	}

	.toggle {
		z-index: 100;
		position: absolute;
		left: -1200px;
		top: -13px;
		width: 15px;
		height: 15px;
		border-radius: 50%;
		border: 7px solid white;
		background-color: black;
		cursor: pointer;
		transition: left ease-out .7s, opacity ease-out .3s;
	}

	.__u {
		border: 7px solid black;
		background-color: #ee6d18;
	}

	.toggle.show {
		left: -48px;
	}

	.uSec {
		border: 7px solid #ee6d18;
		background-color: black;
	}

	.fSec {
		border: 7px solid black;
		background-color: white;
	}

	@media all and (max-width: 1250px) {
		.board-img {
			top: -332px;
			height: 730px;
		}

		.show {
			left: -47px;
		}

		._bottom.show {
			height: 610px;
			top: -281px;
			left: -112px;
		}

		.board {
			height: 424px;
			width: auto;
		}

		.toggle.show {
			top:  -13px;
			left: -98px;
		}
	}


</style>



// WEBPACK FOOTER //
// src/components/board.vue?9a47a9f8